<script lang="ts" setup>
/**
 * The accent dot that marks the current section across every nav surface.
 */
withDefaults(defineProps<{ corner?: boolean }>(), { corner: false })
</script>

<template>
  <span
    aria-hidden="true"
    class="size-2 shrink-0 rounded-full bg-accent-inverted"
    :class="corner ? 'absolute right-1 top-1' : ''"
  />
</template>
